import { del, get, post, put, uploadPut } from '@api/request';

export const fetchHearings = async (
  { assessmentService },
  authenticationToken,
  { taxingUnitID, year },
) => {
  const url = `${assessmentService}/assessment/taxingunit/${taxingUnitID}/hearings/${year}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const createHearing = async (
  { assessmentService },
  authenticationToken,
  { taxingUnitID, year, payload },
) => {
  const url = `${assessmentService}/assessment/taxingunit/${taxingUnitID}/hearings/${year}`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateHearing = async (
  { assessmentService },
  authenticationToken,
  { payload },
) => {
  const { taxingUnitHearingID } = payload;
  const url = `${assessmentService}/assessment/taxingunit/hearing/${taxingUnitHearingID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteHearing = async (
  { assessmentService },
  authenticationToken,
  { payload: { taxingUnitHearingID } },
) => {
  const url = `${assessmentService}/assessment/taxingunit/hearing/${taxingUnitHearingID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const createHearingNotice = async (
  { assessmentService },
  authenticationToken,
  { taxingUnitHearingID, payload },
) => {
  const url = `${assessmentService}/assessment/taxingunit/hearing/${taxingUnitHearingID}/notice`;
  const { body } = await uploadPut(authenticationToken, url, payload);
  return body;
};

export const deleteHearingNotice = async (
  { assessmentService },
  authenticationToken,
  { taxingUnitHearingID },
) => {
  const url = `${assessmentService}/assessment/taxingunit/hearing/${taxingUnitHearingID}/notice`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const getHearingNotice = async (
  { assessmentService },
  authenticationToken,
  { taxingUnitHearingID },
) => {
  const url = `${assessmentService}/assessment/taxingunit/hearing/${taxingUnitHearingID}/notice`;
  const { body } = await get(authenticationToken, url, {
    outputType: 'bytearray',
  });
  return body;
};
